import { render, staticRenderFns } from "./CenterViewCommonPreview_Ap.vue?vue&type=template&id=36114bec&scoped=true"
import script from "./CenterViewCommonPreview_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewCommonPreview_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewCommonPreview_Ap.vue?vue&type=style&index=0&id=36114bec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36114bec",
  null
  
)

export default component.exports